import { v4 as uuid } from 'uuid';
import { User } from "../../../app/main/main.types";
import { AllIngredients, Ingredients, NewIngredients, RecipePresetSubstep } from "../../../app/recipeCreation/createRecipe.types";

export const recipePresets = (presetSelected: RecipePresetSubstep | null) => {
    if (presetSelected) return [{
        id: presetSelected.id,
        image: presetSelected.image,
        name: presetSelected.name,
        subStepId: presetSelected.subStepId,
    }];
    return [];
}

export const ingredientsData = (substepID: string, ingredientList: Array<Ingredients>, user: User | undefined) => {
    const allIngredients: Array<AllIngredients> = [];
    const newIngredientsList: Array<NewIngredients> = [];
    const ingredients = ingredientList?.map((ing: any) => {
        if (ing?.isNewIngredient) newIngredientsList.push({
            id: ing?.id,
            displayName: ing?.displayName,
            created_by: user?.id || null,
        });
        allIngredients.push({
            id: uuid(),
            subStep_id: substepID,
            ingredient_id: ing?.id,
        })
        return {
            ingredients: [{
                amount: {
                    qty: ing?.amount?.qty,
                    unit: ing?.amount?.unit
                },
                default: true,
                ingredientId: ing?.id
            }]
        }
    })
    return { allIngredients, newIngredientsList, ingredients };
}